// Dynamically determine environment from URL
let _cachedEnvironment;
let _loggedEnvironmentDecision = false;
let _lastLoggedTaskEvaEndpoint = '';

const logEnvironmentDecision = (environment) => {
    if (_loggedEnvironmentDecision || typeof window === 'undefined') {
        return;
    }

    _loggedEnvironmentDecision = true;
    console.info('[EVA Env] Active environment resolved', {
        environment,
        hostname: window.location.hostname,
        href: window.location.href,
        source: 'getEnvironmentFromUrl'
    });
};

const logTaskEvaEndpoint = (environment, endpoint) => {
    if (!endpoint || _lastLoggedTaskEvaEndpoint === endpoint) {
        return;
    }

    _lastLoggedTaskEvaEndpoint = endpoint;
    console.info('[EVA Env] TaskEva endpoint selected', {
        environment,
        endpoint,
        source: 'getTaskEvaEndpointUrl'
    });
};

const getEnvironmentFromUrl = () => {
    if (_cachedEnvironment) {
        logEnvironmentDecision(_cachedEnvironment);
        return _cachedEnvironment;
    }
    if (typeof window === 'undefined' || !window.location || !window.location.hostname) {
        _cachedEnvironment = 'production';
        logEnvironmentDecision(_cachedEnvironment);
        return _cachedEnvironment;
    }
    const hostname = window.location.hostname.toLowerCase();
    const pathname = window.location.pathname.toLowerCase();
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        _cachedEnvironment = 'local';
    } else if (hostname.includes('eva-dev')) {
        _cachedEnvironment = 'development';
    } else if (hostname.includes('eva-tst2')) {
        _cachedEnvironment = 'test2';
    } else if (hostname.includes('eva-tst')) {
        _cachedEnvironment = 'testing';
    } else if (hostname.includes('eva-sbx')) {
        _cachedEnvironment = 'sandbox';
    } else if (hostname.includes('eva-stg')) {
        _cachedEnvironment = 'staging';
    } else if (hostname === 'uhgazure.sharepoint.com' && /\/sites\/[^/]*-stg(?:\/|$)/.test(pathname)) {
        _cachedEnvironment = 'staging';
    } else if (pathname.includes('/sites/sparq-online-dev')) {
        _cachedEnvironment = 'testing';
    } else {
        _cachedEnvironment = 'production';
    }
    logEnvironmentDecision(_cachedEnvironment);
    return _cachedEnvironment;
};

const getConversation = () => {
    const params = new URLSearchParams(window.location.search);
    const conversation = {};
    conversation.email = decodeParam(params.get('email'));
    return conversation
}

const decodeParam = (param) => {
    return param ? decodeURIComponent(param) : "";
}

const getInitials = (firstName, lastName) => {
    return (firstName[0] + lastName[0]).toUpperCase();
};

const getEnvironmentUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();

    const environmentUrls = {
        local: process.env.REACT_APP_URL_LOCAL,
        development: process.env.REACT_APP_URL_DEV,
        testing: process.env.REACT_APP_URL_TEST,
        test2: process.env.REACT_APP_URL_TEST2,
        sandbox: process.env.REACT_APP_URL_SBX,
        staging: process.env.REACT_APP_URL_STAGE,
        production: process.env.REACT_APP_URL_PRODUCTION
    };
    
   return environmentUrls[applicationEnvironment];
}

const getEvaSearchEnvironmentUrl = () => {
    let applicationEnvironment = getEnvironmentFromUrl();

    const environmentUrls = {
        development: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_DEV,
        testing: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_TEST,
        test2: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_TEST2,
        sandbox: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_SBX,
        staging: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_STAGE,
        production: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_PRODUCTION,
        local: process.env.REACT_APP_EVA_SEARCH_ENDPOINT_LOCAL,
    };
    // Fall back to sessionStorage endpoint (set by mini-app host) if env vars are not available
    return environmentUrls[applicationEnvironment];
}

const getSmartAnswerEnvironmentUrl = () => {
    let applicationEnvironment = getEnvironmentFromUrl();

    const environmentUrls = {
        development: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_DEV,
        testing: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_TEST,
        test2: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_TEST2,
        sandbox: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_SBX,
        staging: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_STAGE,
        production: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_PRODUCTION,
        local: process.env.REACT_APP_SMART_ANSWER_ENDPOINT_LOCAL,
    };

    return environmentUrls[applicationEnvironment] || getEvaSearchEnvironmentUrl();
}

const getSecurePreviewsEnvironmentUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();

    const environmentUrls = {
        local: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_LOCAL,
        development: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_DEV,
        testing: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_TST,
        test2: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_TST2,
        sandbox: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_SBX,
        staging: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_STAGE,
        production: process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_PROD,
    };

    return environmentUrls[applicationEnvironment] || process.env.REACT_APP_SECURE_PREVIEWS_ENDPOINT_PROD;
}

const getTaskEvaEndpointUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();

        const environmentUrls = {
            development: process.env.REACT_APP_TASKEVA_ENDPOINT_DEV,
            testing: process.env.REACT_APP_TASKEVA_ENDPOINT_TEST,
            test2: process.env.REACT_APP_TASKEVA_ENDPOINT_TEST2,
            sandbox: process.env.REACT_APP_TASKEVA_ENDPOINT_SBX,
            staging: process.env.REACT_APP_TASKEVA_ENDPOINT_STAGE,
            production: process.env.REACT_APP_TASKEVA_ENDPOINT_PRODUCTION,
            local: process.env.REACT_APP_TASKEVA_ENDPOINT_LOCAL,
        };

    const endpoint = environmentUrls[applicationEnvironment];
    logTaskEvaEndpoint(applicationEnvironment, endpoint);
   return endpoint;
}

const getEnvironmentScope = () => {
    const applicationScope = getEnvironmentFromUrl();

    const environmentScope = {
        local: process.env.REACT_APP_SCOPE_NONPROD,
        development: process.env.REACT_APP_SCOPE_NONPROD,
        testing: process.env.REACT_APP_SCOPE_NONPROD,
        test2: process.env.REACT_APP_SCOPE_NONPROD,
        sandbox: process.env.REACT_APP_SCOPE_NONPROD,
        staging: process.env.REACT_APP_SCOPE_NONPROD,
        production: process.env.REACT_APP_SCOPE_PROD
    };
    
   return environmentScope[applicationScope];
}

function getBrowserSessionId() {
    let sessionId = sessionStorage.getItem("browserSessionId");
    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem("browserSessionId", sessionId);
    }
    return sessionId;
  }

  function getInteractionId()
  {
     return crypto.randomUUID();
  }

  const getDarId = () => { 
    const applicationEnvironment = getEnvironmentFromUrl();
    
    const darIds={
    development: process.env.REACT_APP_EVA_DARID_DEV,
    testing: process.env.REACT_APP_EVA_DARID_TEST,
    test2: process.env.REACT_APP_EVA_DARID_TEST2,
    sandbox: process.env.REACT_APP_EVA_DARID_SBX,
    staging: process.env.REACT_APP_EVA_DARID_STAGE,
    production: process.env.REACT_APP_EVA_DARID_PRODUCTION,
    local: process.env.REACT_APP_EVA_DARID_LOCAL,
    }
    return darIds[applicationEnvironment];
}

const getAzureAuthClientId = () => { 
    const applicationEnvironment = getEnvironmentFromUrl();

    const authClientId={
    local: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_LOCAL,
    development: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_DEV,
    testing: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_TEST,
    test2: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_TEST2,
    sandbox: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_SBX,
    staging: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_STAGE,
    production: process.env.REACT_APP_EVA_AZURE_AUTH_CLIENT_ID_PRODUCTION,
    }
    return authClientId[applicationEnvironment];
}

const getTokenUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const tokenUrl={
        local: process.env.REACT_APP_LIVECHAT_LOCAL,
        development: process.env.REACT_APP_LIVECHAT_DEV,
        testing: process.env.REACT_APP_LIVECHAT_TEST,
        test2: process.env.REACT_APP_LIVECHAT_TEST2,
        sandbox: process.env.REACT_APP_LIVECHAT_SBX,
        staging: process.env.REACT_APP_LIVECHAT_STAGE,
        production: process.env.REACT_APP_LIVECHAT_PRODUCTION
    };
    return tokenUrl[applicationEnvironment];
}
const getLiveChatUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const environmentUrls = {
        local: process.env.REACT_APP_EVA_LIVE_CHAT_URL_LOCAL,
        development: process.env.REACT_APP_EVA_LIVE_CHAT_URL_DEV,
        sandbox: process.env.REACT_APP_EVA_LIVE_CHAT_URL_SBX,
        testing: process.env.REACT_APP_EVA_LIVE_CHAT_URL_TEST,
        test2: process.env.REACT_APP_EVA_LIVE_CHAT_URL_TEST2,
        staging: process.env.REACT_APP_EVA_LIVE_CHAT_URL_STAGE,
        production: process.env.REACT_APP_EVA_LIVE_CHAT_URL_PRODUCTION
    };
    return environmentUrls[applicationEnvironment];
}

// EC live agent REST base URL (start-conversation endpoint lives here).
const getECLiveChatUrl = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const environmentUrls = {
        local: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_LOCAL,
        development: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_DEV,
        sandbox: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_SBX,
        testing: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_TEST,
        test2: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_TEST2,
        staging: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_STAGE,
        production: process.env.REACT_APP_EVA_EC_LIVE_CHAT_URL_PRODUCTION
    };
    return environmentUrls[applicationEnvironment];
}


// EC upstream environment code sent as `x-upstream-env` on non-production
// requests. Production intentionally omits this header.
const getECUpstreamEnv = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    if (applicationEnvironment === 'production') return undefined;
    if (applicationEnvironment === 'staging') return 'stg';

    const baseUrl = (getECLiveChatUrl() || '').toLowerCase();

    // The upstream env is encoded in the service path segment
    // (e.g. ec-liveagent-service-dev / -tst / -stg), not in the api-stg host.
    const serviceEnvMatch = baseUrl.match(/ec-liveagent-service-([a-z0-9]+)/);
    const envCode = serviceEnvMatch ? serviceEnvMatch[1] : '';

    if (envCode.includes('prod')) return 'prod';
    if (envCode.includes('stg') || envCode.includes('stage')) return 'stg';
    if (envCode.includes('sbx') || envCode.includes('sandbox')) return 'sbx';
    if (envCode.includes('tst2') || envCode.includes('test2')) return 'test2';
    if (envCode.includes('tst') || envCode.includes('test')) return 'tst';
    if (envCode.includes('dev')) return 'dev';

    // Match the proxy's default when the env cannot be inferred from the URL.
    return 'dev';
}

const getFileUploadUItoStorageUrl = () => { 
    const applicationEnvironment = getEnvironmentFromUrl();

    const fileUploadUItoStorageUrl={
    local: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_LOCAL,
    development: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_DEV,
    testing: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_TEST,
    test2: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_TEST2,
    sandbox: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_SBX,
    staging: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_STAGE,
    production: process.env.REACT_APP_EVA_FILEUPLOAD_UI_TO_STORAGE_PRODUCTION,
    }
    return fileUploadUItoStorageUrl[applicationEnvironment];
}
const getTakeATour = () => { 
    const applicationEnvironment = getEnvironmentFromUrl();

    const takeATourUrl={
    local: process.env.REACT_APP_EVA_TAKE_A_TOUR_LOCAL,
    development: process.env.REACT_APP_EVA_TAKE_A_TOUR_DEV,
    sandbox: process.env.REACT_APP_EVA_TAKE_A_TOUR_SBX,
    testing: process.env.REACT_APP_EVA_TAKE_A_TOUR_TEST,
    test2: process.env.REACT_APP_EVA_TAKE_A_TOUR_TEST2,
    staging: process.env.REACT_APP_EVA_TAKE_A_TOUR_STAGE,
    production: process.env.REACT_APP_EVA_TAKE_A_TOUR_PRODUCTION,
    }
    return takeATourUrl[applicationEnvironment];
}

const getUtilitiesApiUrl = () => { 
    const applicationEnvironment = getEnvironmentFromUrl();

    const utilitiesApiUrl={
    local: process.env.REACT_APP_UTILITIES_API_URL_LOCAL,
    development: process.env.REACT_APP_UTILITIES_API_URL_DEV,
    sandbox: process.env.REACT_APP_UTILITIES_API_URL_SBX,
    testing: process.env.REACT_APP_UTILITIES_API_URL_TEST,
    test2: process.env.REACT_APP_UTILITIES_API_URL_TEST2,
    staging: process.env.REACT_APP_UTILITIES_API_URL_STAGE,
    production: process.env.REACT_APP_UTILITIES_API_URL_PRODUCTION,
    }
    return utilitiesApiUrl[applicationEnvironment];
}
const getAzureStorageAccount = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const azureStorageAccount = {
        local: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_LOCAL,
        development: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_DEV,
        testing: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_TEST,
        test2: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_TEST2,
        staging: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_STAGE,
        production: process.env.REACT_APP_EVA_AZURE_STORAGE_ACCOUNT_PRODUCTION,
    };
    return azureStorageAccount[applicationEnvironment];
};
const getPersonaSwitchEnabled = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const rawValue = applicationEnvironment === 'production'
        ? process.env.REACT_APP_ENABLE_PERSONA_SWITCH_PROD
        : process.env.REACT_APP_ENABLE_PERSONA_SWITCH_NONPROD;
    return rawValue === 'true';
};
const getSessionLogsFlagEnabled = () => {
    const applicationEnvironment = getEnvironmentFromUrl();
    const sessionLogsFlagEnabled = {
        local: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_LOCAL,
        development: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_DEV,
        sandbox: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_SBX,
        testing: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_TEST,
        test2: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_TEST2,
        staging: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_STAGE,
        production: process.env.REACT_APP_AIRB_EVA_SESSION_LOGS_FLAG_ENABLED_PRODUCTION,
    };
    const rawValue = sessionLogsFlagEnabled[applicationEnvironment];
    return rawValue === 'true';
};
export {
    getConversation,
    getInitials,
    getEnvironmentUrl,
    getEnvironmentFromUrl,
    getEnvironmentScope,
    getBrowserSessionId,
    getInteractionId,
    getEvaSearchEnvironmentUrl,
    getSmartAnswerEnvironmentUrl,
    getSecurePreviewsEnvironmentUrl,
    getTaskEvaEndpointUrl,
    getDarId,
    getAzureAuthClientId,
    getTokenUrl,
    getLiveChatUrl,
    getECLiveChatUrl,
    getECUpstreamEnv,
    getFileUploadUItoStorageUrl,
    getTakeATour,
    getUtilitiesApiUrl,
    getAzureStorageAccount,
    getSessionLogsFlagEnabled,
    getPersonaSwitchEnabled
};